<template>
  <div class="time-record-takt-time-container">
    <!-- TODO: this id should be set by a prop -->
    <RadioButtonSquare
      v-for="(square, index) in time_squares"
      :key="`${square.description}${index}`"
      :id="`${square.description}${index}`"
      :description="square.description"
      :is_active="selected_day === square.description"
      :is_badge="square.is_badge"
      :is_disabled="square.is_disabled"
      :is_invisible="square.is_invisible"
      :items_per_row="items_per_row"
      :background_color="background_color"
      :foreground_color="foreground_color"
      @setActive="$emit('clickDay', square.description)"
    >
      <template #badge>
        <TIcon
          name="check"
          :color="foreground_color"
          size="18"
        />
      </template>
      <template #content>
        <TText
          class="time-record-takt-time-square-text"
          :text="square.description"
          medium
          :color="selected_day === square.description
            ? background_color
            : foreground_color"
        />
      </template>
    </RadioButtonSquare>


  </div>
</template>

<script>
import RadioButtonSquare from '@/components/WorkPackageWIP/RadioButtonSquare.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
// import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';

  export default {
    components: {
      RadioButtonSquare,
      TText,
      TIcon,
    },

    props: [
      'time_squares', // is array of elements, contains description (string) and is_badge, is_disabled, is_invisible (boolean)
      'selected_day',
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'items_per_row'
    ],

    // mixins: [
    //   WorkPackageWIPMixin,
    // ],

    data: () => ({

    }),

    methods: {

    },

    mounted() {
      // this.initDynWidth('ultra-container', 5, 8);
      // this.initRadioBtns(false, true, 'We2'); // TODO: default_btn should be dynamic!
    },
  }
</script>

<style>
  .time-record-takt-time-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    grid-gap: 8px;
    flex-wrap: wrap;
    padding-top: 15px;
  }
  .time-record-takt-time-square-text {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
